module.exports = __webpack_public_path__ + "img/hr-curved-rail-horizontal-left-top-metals.f11f4112.png";